import {matchPath} from "react-router-dom-v5-compat";

/**
 * Determines if the given path is an Exercise page.
 */
export const isExercisePage = (path: string): boolean =>
    !!matchPath("/:domain/:course/:unit/:lesson/e/:slug", path);
